export enum EOccurrenceType {
	datetime = "datetime",
	intervenants = "intervenants",
	range = "range"
}